import { useEffect, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from "../context/UserContext"; // Ruta corregida

const useLogoutValid = (timeoutInMinutes = 120) => {
  const history = useHistory();
  const { logout } = useContext(UserContext);
  const logoutTime = timeoutInMinutes * 60 * 1000;

  const handleLogout = useCallback(() => {
    console.log("Sesión expirada por inactividad.");

    // 1. LIMPIEZA DE ESTADO DE REACT
    if (typeof logout === 'function') {
      logout();
    }

    // 2. LIMPIEZA DE DISCO (LocalStorage)
    localStorage.removeItem("user_myaccount_id");
    localStorage.removeItem("salesman");
    localStorage.removeItem("last_activity");
    localStorage.removeItem("checkout_payload");
    
    // 3. REDIRECCIÓN
    history.push("/login");
    
    // 4. RECARGA (Opcional pero recomendado para limpiar todos los Contexts)
    window.location.reload();
  }, [history, logout]);

  useEffect(() => {
    const user = localStorage.getItem("user_myaccount_id");
    if (!user) return;

    // Verificar ANTES de resetear el timer si la sesión ya expiró
    const lastActivity = localStorage.getItem("last_activity");
    if (lastActivity && (Date.now() - parseInt(lastActivity) > logoutTime)) {
      handleLogout();
      return;
    }

    let timer;

    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      localStorage.setItem("last_activity", Date.now().toString());
      timer = setTimeout(() => {
        handleLogout();
      }, logoutTime);
    };

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];

    resetTimer();

    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    return () => {
      if (timer) clearTimeout(timer);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [handleLogout, logoutTime]);

  return { handleLogout };
};

export default useLogoutValid;